<template>
  <transition :name="`slide-${getDirection()}`">
    <FormulateInput v-if="isActive" :key="name" type="group" :name="name">
      <div
        ref="container"
        v-resize="updateCurrentStepHeight"
        v-bem="{ noFooter: !hasFooterSlot }"
        :style="{ position: 'absolute' }"
      >
        <slot />
        <div v-if="hasFooterSlot" v-bem:footer>
          <slot name="footer" />
        </div>
      </div>
    </FormulateInput>
  </transition>
</template>

<script>
export default {
  name: 'WizardStep',
  props: {
    name: {
      type: String,
      required: true,
    },
    confirmation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      direction: 'forward',
    };
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
  watch: {
    isActive() {
      this.$nextTick(() => {
        this.updateCurrentStepHeight();
      });
    },
  },
  inject: ['registerStep', 'setCurrentStepHeight', 'getDirection'],
  mounted() {
    this.registerStep(this);
  },
  methods: {
    updateCurrentStepHeight() {
      if (this.isActive && this.$refs.container) {
        this.setCurrentStepHeight(this.$refs.container.offsetHeight);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';

.wizard-step {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: utils.f-rem-calc(350);
  padding: utils.f-rem-calc(utils.$v-wizard-sm-gap-y)
    utils.f-rem-calc(utils.$v-wizard-sm-gap-x) 0;

  @include utils.bs-media-breakpoint-up(md) {
    padding: utils.f-rem-calc(utils.$v-wizard-gap-y)
      utils.f-rem-calc(utils.$v-wizard-gap-x) 0;
  }

  @include utils.bs-media-breakpoint-up(md) {
    display: flex;
    flex-direction: column;
  }

  @at-root #{&}--no-footer {
    padding-bottom: utils.f-rem-calc(30);

    @include utils.bs-media-breakpoint-up(md) {
      padding-bottom: utils.f-rem-calc(40);
    }
  }

  @at-root #{&}__footer {
    @include utils.bs-media-breakpoint-up(md) {
      margin-top: auto;
    }
  }
}

.slide-forward {
  &-leave-active,
  &-enter-active {
    transition: all 450ms ease;
  }
  &-enter {
    transform: translate(100%, 0);
  }
  &-leave-to {
    transform: translate(-100%, 0);
  }
}

.slide-backward {
  &-leave-active,
  &-enter-active {
    transition: all 450ms ease;
  }
  &-enter {
    transform: translate(-100%, 0);
  }
  &-leave-to {
    transform: translate(100%, 0);
  }
}
</style>
